import {
  ActiveFilter,
  ActiveFiltersBar,
  Input,
  TableFilter,
  TableFilters,
} from '../../../../../../components'
import { useListFilters } from '../../core/ListFiltersProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useAtendimentosFiltrados } from '../../core/useAtendimentosFiltrados'
import { useT } from '_metronic/i18n/Metronici18n'

export const NotaAtendimentosListHeader = () => {
  const { t } = useT()
  const { isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const total = useAtendimentosFiltrados().length

  const activeFilters: ActiveFilter[] = filters.protocolo.trim()
    ? [
        {
          key: 'protocolo',
          label: t('protocolo.label'),
          value: `“${filters.protocolo.trim()}”`,
          onRemove: () => setFilter('protocolo', ''),
        },
      ]
    : []

  return (
    <div className='card-header border-0 pt-6'>
      <TableFilters
        footer={
          <ActiveFiltersBar
            filters={activeFilters}
            onClearAll={clearFilters}
            summary={
              isLoading
                ? 'Buscando…'
                : `${total} ${total === 1 ? 'atendimento encontrado' : 'atendimentos encontrados'}`
            }
          />
        }
      >
        <TableFilter label={t('protocolo.label')} wide>
          <Input
            entity='protocolo'
            value={filters.protocolo}
            onChange={(e) => setFilter('protocolo', e.target.value)}
          />
        </TableFilter>
      </TableFilters>
    </div>
  )
}
